import { createEmptySliceBase, injectTabSlice, toReducer } from '../sliceFactory';

const createAdminApplicationsReducer = () => {
  const sliceBase = createEmptySliceBase({ name: 'applications' });
  const withTabs = injectTabSlice({ initialTab: 0, sliceBase });
  return toReducer(withTabs);
};

export default createAdminApplicationsReducer;
